import { DatePipe } from '@angular/common';
import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { Router } from '@angular/router';
import { ApiService } from 'app/services/api.service';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'app-all-gates',
  templateUrl: './all-gates.component.html',
  styleUrls: ['./all-gates.component.css']
})
export class AllGatesComponent implements OnInit{
  Bstatus = 'Cancelled';
  color='';
  isPotrait:boolean = false;
  gates:any[]=[];
  gatesaray:any[] = [];
  spinner:boolean = false;
  sessionid;
  searchshow:boolean = false;
  Searchtext: any =''
  langconfig;
  constructor(private apiService: ApiService,private router: Router, private devicedetails: DeviceDetectorService) {
    this.checkorientation();
    this.apiService.language.subscribe((res)=>{
      const langcode = res.code
      this.langconfig = langcode == 'En' ? require("../../Language/En-us.json") : require("../../Language/It-us.json")
    })
   }

   @HostListener('window:resize', ['$event'])
   onResize(event: Event): void {
     this.checkorientation();
     // this.calldata();
   }
 

  ngOnInit() {
    sessionStorage.removeItem('sessionId');
    this.spinner = true;
    this.apiService.getallgates().subscribe(res =>{
        this.gates = res.data
        this.gatesaray = res.data
        this.spinner = false;
    },(error)=>{
      this.spinner= false;
    })
  }

  checkorientation(){
    this.isPotrait = window.innerHeight < window.innerWidth ? true : false
  }

  opengate(gate){
    const devicedetails = this.devicedetails.getDeviceInfo();
    const deviceres = window.innerHeight + '*' + window.innerWidth;
    const devicetype = this.devicedetails.isTablet() ? 'Tablet' : this.devicedetails.isMobile() ? 'Mobile' : this.devicedetails.isDesktop() ? 'Desktop' : 'Others';
    const param = {
      browser_name : devicedetails.browser,
      browser_version: devicedetails.browser_version,
      device_name: devicedetails.device,
      os_name: devicedetails.os,
      os_version: devicedetails.os_version,
      user_agent: devicedetails.userAgent,
      resolution: deviceres,
      device_type: devicetype,
      gate: gate.gate_no
    }
    this.spinner =true;
    this.apiService.gates_api(gate.gate_no).subscribe(response => {
          let responsedata = response.data.filter(item => item !== response.data[1])
            this.apiService.setSharedData(responsedata);  
            this.apiService.getsession(param).subscribe(res =>{
                if(res.id){
                  sessionStorage.setItem('qrimage', res.qr_image);
                  this.sessionid = res.id
                  this.spinner = false;
                  this.router.navigate(['/pax'],{ queryParams: { gateno: gate.gate_no, pax_view_session: this.sessionid } })
                  this.apiService.setsessionId('sessionId', this.sessionid,2);
                }
                this.spinner = false;
              },(error)=>{
                this.spinner = false;
              })
        },(error)=>{
          this.spinner = false;
        })   
  }
  searchactive:boolean = false;
  searchValue() {
    this.searchactive = false;
    if(!this.searchactive && this.Searchtext.length>0){
      let gatesarray = [];
      this.gates = this.gatesaray;
        this.gates.find(gate => {
          if (gate && (gate && gate.flight && gate.flight.toLowerCase().includes(this.Searchtext.toLowerCase())) || (gate && gate.gate_no && gate.gate_no.toLowerCase().includes(this.Searchtext.toLowerCase())) || (gate && gate.destination && gate.destination.toLowerCase().includes(this.Searchtext.toLowerCase()))) {
            gatesarray.push(gate);
          }
        })    
      this.gates = gatesarray && gatesarray[0] != undefined ? gatesarray : [];
      this.searchactive = true;
    }
  }

  clearsearch(){
    this.Searchtext = '';
    this.searchactive = false;
    this.gates = this.gatesaray;
  }

}
